import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'

import TopNav from './navigation/TopNav'

@inject(['auth'])
@observer
class App extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  componentWillMount() {
    this.authWatcher = when(
      () => !this.props.auth.loggedIn,
      () => this.context.router.push({ pathname: '/login', state: { return_to: this.props.location } })
    )
  }

  componentWillUnmount() {
    this.authWatcher()
  }

  render() {
    const { auth, children } = this.props

    return (
      <div className="container app">
        <TopNav auth={auth} />
        {children}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// client/components/App.js